"use client";

import Link from "next/link";
import { Container } from "@/components/ui/container";
import { Button } from "@/components/ui/button";

export default function GlobalError({ reset }: { error: Error; reset: () => void }) {
  return (
    <Container className="py-16 text-center md:py-24">
      <p className="text-sm font-medium uppercase tracking-wide text-error-600">
        Ошибка 500
      </p>
      <h1 className="mt-2 text-3xl font-bold md:text-4xl">Что-то пошло не так</h1>
      <p className="mx-auto mt-4 max-w-md text-text-muted">
        Мы уже знаем о проблеме. Попробуйте обновить страницу через минуту или
        вернитесь в каталог.
      </p>
      <div className="mt-8 flex justify-center gap-3">
        <Button onClick={() => reset()}>Попробовать снова</Button>
        <Link href="/catalog">
          <Button variant="ghost">В каталог</Button>
        </Link>
      </div>
    </Container>
  );
}
